import {prefix} from "app/config/routes/tp/_cfg";

export const routeTP = {
    'tp':           `${prefix}`,
    'tp.dashboard': `${prefix}`,
}